import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    date,
    taxAgencyName,
    period,
    resolutions,
    dividends,
    profits,
    taxId,
    taxId2,
    taxpayerName,
    timeSign,
    taxAgentContract,
    conpanyName,
  },
} = checkout;

const initialValues = {
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [conpanyName.name]: "",
  [date.name]: "",
  [taxAgencyName.name]: "",
  [period.name]: "",
  [resolutions.name]: "",
  [profits.name]: "",
  [dividends.name]: "",
  [taxId.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [taxAgentContract.name]: "",
};

export default initialValues;
